import type { JSONContent } from '@tiptap/react';

import { z } from 'zod';

import { forumTags } from './constants';

export const forumTagSchema = z.enum(forumTags);

export const forumUserSchema = z.object({
  isModerator: z.literal(false),
  communityProfileId: z.number(),
  firstName: z.string(),
  brandName: z.string().nullable(),
  profilePictureUrl: z.url().nullable(),
});

export const forumModeratorSchema = z.object({
  isModerator: z.literal(true),
  communityProfileId: z.null(),
  firstName: z.string(),
  brandName: z.string(),
  profilePictureUrl: z.url().nullable(),
});

export const forumAuthorSchema = z.discriminatedUnion('isModerator', [forumUserSchema, forumModeratorSchema]);

export const forumPostSchema = z.object({
  id: z.number(),
  tag: forumTagSchema,
  author: forumAuthorSchema,
  title: z.string(),
  content: z.json().pipe(z.custom<JSONContent>()),
  numberOfComments: z.number(),
  saved: z.boolean(),
  likes: z.number().array(),
  pinned: z.boolean(),
  locked: z.boolean(),
  deletable: z.boolean(),
  createdAt: z.iso.datetime({ offset: true }),
  editedAt: z.iso.datetime({ offset: true }).nullable(),
});

export const forumCommentSchema = z.object({
  id: z.number(),
  postId: z.number(),
  author: forumAuthorSchema,
  content: z.json().pipe(z.custom<JSONContent>()),
  createdAt: z.iso.datetime({ offset: true }),
  editedAt: z.iso.datetime({ offset: true }).nullable(),
});

export const forumPostSystemMessageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('LockedByModerator'),
    data: z.object({ firstName: z.string().nullable() }),
    displayedAt: z.iso.datetime({ offset: true }),
  }),
  z.object({
    type: z.literal('MovedByModerator'),
    data: z.object({ firstName: z.string().nullable(), oldTag: forumTagSchema, newTag: forumTagSchema }),
    displayedAt: z.iso.datetime({ offset: true }),
  }),
  z.object({
    type: z.literal('CommentDeletedByUser'),
    data: z.null(),
    displayedAt: z.iso.datetime({ offset: true }),
  }),
  z.object({
    type: z.literal('CommentDeletedByModerator'),
    data: z.object({ firstName: z.string().nullable() }),
    displayedAt: z.iso.datetime({ offset: true }),
  }),
]);
